import PropTypes from 'prop-types';
import React from 'sitewide-react';
import RedesignedMentionsPing from './redesigned_mentions_ping.wjs';

class MentionsPing extends RedesignedMentionsPing {
  getBody() {
    return this.props.type === 'paper'
      ? this.getPaperText()
      : this.getAuthorText();
  }

  getUpgradeURL() {
    return $r.upgrade_url({
      feature: 'searchm',
      trigger: 'mentions-view-download-onsite-ping',
      after_upgrade_path: encodeURIComponent($r.mentions_path()),
    });
  }

  getPaperText() {
    const article = $h.aOrAn(this.props.researchInterestName);
    return (
      <div className="text">
        The name <strong>{this.props.mentionedName}</strong> is{' '}
        {this.mentionVerb()} in {article}{' '}
        <strong>{this.props.researchInterestName}</strong> paper uploaded to
        Academia.
      </div>
    );
  }

  getAuthorText() {
    const article = $h.aOrAn(this.props.researchInterestName);
    return (
      <div className="text">
        The name <strong>{this.props.mentionedName}</strong> is{' '}
        {this.mentionVerb()} by {article}{' '}
        <strong>{this.props.researchInterestName}</strong> researcher in a paper
        uploaded to Academia.
      </div>
    );
  }
}

MentionsPing.propTypes = {
  mentionId: PropTypes.number.isRequired,
  researchInterestId: PropTypes.number.isRequired,
  mentionedName: PropTypes.string.isRequired,
  researchInterestName: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};

export default MentionsPing;
